export default __webpack_public_path__ + "static/media/newdetail.8db657bb.jpg";